// Category circles: Swiper slider on mobile only; plain centered row on desktop.
const MOBILE_QUERY = window.matchMedia('(max-width: 749px)');

class CategoryCircles extends HTMLElement {
  connectedCallback() {
    this.swiper = null;
    this.onChange = () => this.update();

    // swiper.js is loaded with "defer"; wait for it if this module runs first
    if (window.Swiper) {
      this.init();
    } else {
      window.addEventListener('load', () => this.init(), { once: true });
    }
  }

  disconnectedCallback() {
    MOBILE_QUERY.removeEventListener('change', this.onChange);
    this.destroy();
  }

  init() {
    MOBILE_QUERY.addEventListener('change', this.onChange);
    this.update();
  }

  update() {
    if (MOBILE_QUERY.matches) {
      this.create();
    } else {
      this.destroy();
    }
  }

  create() {
    if (this.swiper || !window.Swiper) return;

    const perView = parseFloat(this.dataset.mobilePerView) || 4.5;

    this.swiper = new window.Swiper(this, {
      slidesPerView: perView,
      spaceBetween: 12,
      freeMode: true,
      watchOverflow: true,
    });
  }

  destroy() {
    if (!this.swiper) return;
    // Remove Swiper's inline styles so the desktop flex layout takes over again
    this.swiper.destroy(true, true);
    this.swiper = null;
  }
}

if (!customElements.get('category-circles')) {
  customElements.define('category-circles', CategoryCircles);
}
